/// <reference types="./authGetPrincipals.d.ts" />
import { ok, } from '@dossierhq/core';
import { fetchAndDecodeConnection } from '../utils/fetchAndDecodeConnection.js';
export function autGetPrincipals(databaseAdapter, context, paging) {
    return fetchAndDecodeConnection(paging, (pagingInfo) => databaseAdapter.authGetPrincipals(context, pagingInfo), ({ cursor, ...principal }) => ok(principal));
}
//# sourceMappingURL=authGetPrincipals.js.map